/* global $ */

/**
 * Render a single list item DOM node
 * @param  {String} label    Text to render
 * @return {Node}            Native DOM node
 */
export default (label, image = null, price = null) => {
  const html = `
    <li class="awesomplete__item" aria-selected="false">
      <div class="awesomplete__item-image">
        <img src="${image}" alt="" class="img-fluid">
      </div>
      <div class="awesomplete__item-body">
        <span>${label}</span>
        <span class="awesomplete__item-price">${price}</span>
      </div>
    </li
  `;

  const item = $(html)[0];

  return item;
};
